import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

export const ExtendDurationExpiredPanel = () => {
  return (
    <ShortMessageBox variant="error" icon={<MessageBoxIcon size={"md"} variant="error" />}>
      <BodySM className="text-error-text">
        This veSCALE NFT has expired and you are unable to extend the duration of an expired NFT.
      </BodySM>
    </ShortMessageBox>
  )
}
